import React, { Component } from "react";
import { connect } from 'react-redux';
import { NavigationHeader } from "../../layout/components/navigationheader/NavigationHeader";
import { GET_STUDIO_APPS_FROM_API, studioApps } from '../../../../../../../actions/sceneActions'
import { CloudUrlStudio } from "../../../../../../../actions/api";
import { getInitialRoute } from "../../../../../../../utils";

class WidgetApps extends Component {
    state = {
        apps: []
    }
    componentDidMount() {  
        GET_STUDIO_APPS_FROM_API().then((layoutResponse) => {
            if (layoutResponse.data) {
                const { apps } = layoutResponse.data;
                this.setState({ apps }, () => this.props.studioApps(this.state.apps))
            }
        })
            .catch((error) => {
                console.log("LAYOUT ISSUE", error)
            });

    }
    onClickToAddApp = (appID) => event => {
        const { location, history } = this.props;
        history(`${location.pathname}/${appID}`)
    }

    render() {
        const { match } = this.props
        const { apps } = this.state;
        
        return (
        <div className=""> 
            <NavigationHeader name="Apps" backToNavigation={`/studio/${match.params.wallId}`} />
            {/* viw_flex_center */}
            <div className="subheader_content">
                <div className="container">
                    <div className="row">
                        {
                            apps && apps.length > 0 && apps.map((item, keyIndex) => <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 cursor-pointer mb-5" key={keyIndex} onClick={this.onClickToAddApp(item.id)}>
                                <div className="card card-custom overflow-hidden card-stretch">
                                    <div className="card-body p-0">
                                        <div className="d-flex align-items-center justify-content-center apps_card_img">
                                            <img src={`${CloudUrlStudio}/app_icons/${item.name.replace(/ /g,'')}.svg?v=1`} className="img-fluid" alt={item.name} />
                                        </div>
                                        <div className="p-5 mb-2">
                                            <h3 className="mb-2">{item.name}</h3>
                                            <p className="font-size-lg font-weight-normal">
                                                {item.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
        // <LeaderBoard />
        )
    }

}
const mapStateToProps = state => {  
    return { 
        studioWall: state.studio.studioWall
    }
}
const mapDispatchToProps = dispatch => {
    return {
        studioApps: (data) => dispatch(studioApps(data)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(WidgetApps);